let load = require('./helpers/browser/esm-js-loader-shards-super.js')(4);
module.exports = (load("1FBc6")).then(() => parcelRequire('4EBSv'));